import { apiClient } from '@/libs/api'

export type FetchMonthlyCustomerReportQuery = {
  tenantKey: string
  monthlyCustomerReportId: number
}

export const fetchMonthlyCustomerReport = async (
  { tenantKey, monthlyCustomerReportId }: FetchMonthlyCustomerReportQuery,
  signal?: AbortSignal
) => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .monthly_customer_reports._id(monthlyCustomerReportId)
    .$get({
      config: { signal }
    })
  return data
}
